import { Svg, type Props as SvgProps } from './Svg'

export const IconMail = (props: SvgProps) => (
	<Svg {...props} viewBox='0 0 24 24' fill='currentcolor' xmlns='http://www.w3.org/2000/svg'>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M15.207 12.207L20 7.414V17L15.207 12.207ZM10.207 13.621L10.585 14C11.367 14.781 12.633 14.781 13.414 14L13.793 13.621L18.171 18H5.829L10.207 13.621ZM8.793 12.207L4 17V7.414L8.793 12.207ZM12 12.585L5.414 6H18.586L12 12.585ZM20 4H4C2.895 4 2 4.895 2 6V18C2 19.104 2.895 20 4 20H20C21.104 20 22 19.104 22 18V6C22 4.895 21.104 4 20 4Z'
		/>
	</Svg>
)
